import { useEffect, useState } from "react";
import "./App.css";
import RepositoryList from "./page/RepositoryList/RepositoryList";

interface Repository {
  id: number;
  name: string;
  description: string;
  language: string; 
  forks: number;
  created_at: string;
  owner: {
    login: string;
  };
}

function App() {
  const [repositories, setRepositories] = useState<Repository[]>([]);
  const [languages, setLanguages] = useState<string[]>([]);

  useEffect(() => {
    fetch("https://welast-node-express.vercel.app/repos")
      .then((response) => response.json())
      .then((data) => {
        let uniqueLanguages: string[] = ["All"];
        data.forEach((element: Repository) => {
          if (
            element.language != null &&
            !uniqueLanguages.includes(element.language)
          ) {
            uniqueLanguages.push(element.language);
          }
        });
        setRepositories(data);
        setLanguages(uniqueLanguages);
      })
      .catch((error) => {
        console.error("Error fetching repositories:", error);
        alert("API rate limit exceeded, please wait");
      });
  }, []);
  return (
    <div className="App">
      <h1>WeLAST Github Repositories</h1>
      <RepositoryList languages={languages} repositories={repositories} />
    </div>
  );
}

export default App;
